import { gql, QueryHookOptions, useQuery, useLazyQuery } from '@apollo/client';
import { Exception } from '@jewelutions/core-common-domain';
import {
  GQLMerchantChannelCatalog,
  GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs,
  GQLQueryMerchantChanelCatalog_GetDesignerCatalogFromMerchantChannelCatalogArgs
} from '@jewelutions/core-crm-server-api-client-domain';
import { MERCHANT_CHANNEL_CATALOG_FIELDS } from './fragments/merchant';

export class MerchantChannelCatalogOperation {
  designerCatalogFromResponse(data: any): string {
    if (data === undefined) {
      throw new Exception(`Cannot extract designer catalog from undefined input data`);
    }
    if (data.MerchantChanelCatalog_getDesignerCatalogFromMerchantChannelCatalog !== undefined) {
      return data.MerchantChanelCatalog_getDesignerCatalogFromMerchantChannelCatalog;
    }
    throw new Exception(`Cannot extract designer catalog from expected fields in input data`);
  }

  merchantChannelCatalogFromResponse(data: any): GQLMerchantChannelCatalog {
    if (data === undefined) {
      throw new Exception(`Cannot extract merchant channel catalog from undefined input data`);
    }
    if (data.MerchantChanelCatalog_getMerchantChannelCatalog !== undefined) {
      return data.MerchantChanelCatalog_getMerchantChannelCatalog;
    }
    throw new Exception(`Cannot extract merchant channel catalog from expected fields in input data`);
  }

  getMerchantChannelCatalog(
    args: GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs,
    options: QueryHookOptions<
      GQLMerchantChannelCatalog,
      GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs
    > = {}
  ) {
    return useQuery<GQLMerchantChannelCatalog, GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs>(
      this.query.MerchantChannelCatalog_getMerchantChannelCatalog,
      { ...options, variables: args }
    );
  }

  getMerchantChannelCatalogLazy(
    args: GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs,
    options: QueryHookOptions<
      GQLMerchantChannelCatalog,
      GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs
    > = {}
  ) {
    return useLazyQuery<
      GQLMerchantChannelCatalog,
      GQLQueryMerchantChanelCatalog_GetMerchantChannelCatalogArgs
    >(this.query.MerchantChannelCatalog_getMerchantChannelCatalog, { ...options, variables: args });
  }
  private query = {
    MerchantChannelCatalog_getMerchantChannelCatalog: gql`
      ${MERCHANT_CHANNEL_CATALOG_FIELDS}
      query getMerchantChannelCatalog($merchantChannelCatalogId: ID!) {
        MerchantChanelCatalog_getMerchantChannelCatalog(merchantChannelCatalogId: $merchantChannelCatalogId) {
          ...MerchantChannelCatalogFields
        }
      }
    `
  };

  getDesignerCatalogFromMerchantChannelCatalog(
    args: GQLQueryMerchantChanelCatalog_GetDesignerCatalogFromMerchantChannelCatalogArgs,
    options: QueryHookOptions<
      string,
      GQLQueryMerchantChanelCatalog_GetDesignerCatalogFromMerchantChannelCatalogArgs
    > = {}
  ) {
    const query = gql`
      query getDesignerCatalogFromMerchantChannelCatalog($merchantChannelCatalogId: ID!) {
        MerchantChanelCatalog_getDesignerCatalogFromMerchantChannelCatalog(
          merchantChannelCatalogId: $merchantChannelCatalogId
        )
      }
    `;
    return useQuery<string, GQLQueryMerchantChanelCatalog_GetDesignerCatalogFromMerchantChannelCatalogArgs>(
      query,
      {
        ...options,
        variables: args
      }
    );
  }
}
